import { useCallback, useEffect, useState } from 'react';
import Decimal from 'decimal.js';
import { pathgen } from 'object-path-generator';
import { CloseButton, Popover, useStateInRef } from 'seagull';
import { serviceModel } from "../../models";
import styles from "./BundlePriceEditor.module.scss";
import { getBundlePriceEditorData } from "./BundlePriceEditor.utils";
import { BundlePriceEditorContent } from "./BundlePriceEditorContent";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const BundlePriceEditorTestIds = pathgen('BundlePriceEditorTestIds');
export function BundlePriceEditor(props) {
  const getProps = useStateInRef(props);
  const {
    serviceWithChanges,
    editorAnchor,
    isOpen,
    onInputFocus,
    onInputBlur
  } = props;
  const {
    bundle
  } = serviceWithChanges;
  const [editorData, setEditorData] = useState(() => getBundlePriceEditorData(serviceWithChanges));
  useEffect(() => {
    setEditorData(getBundlePriceEditorData(serviceWithChanges));
  }, [serviceWithChanges, bundle]);
  function onSave(e) {
    e.preventDefault();
    const {
      service,
      setIsOpen,
      onChangeService
    } = getProps();
    const newService = serviceModel.setBundlePrice(service, editorData.includedServiceRates, new Decimal(editorData.bundleRate), +editorData.discount > 0 ? new Decimal(editorData.discount) : null);
    onChangeService(newService);
    setIsOpen(false);
  }
  const onDismiss = useCallback(() => {
    const {
      serviceWithChanges,
      setIsOpen
    } = getProps();
    setIsOpen(false);
    setTimeout(() => {
      setEditorData(getBundlePriceEditorData(serviceWithChanges));
    }, 100);
  }, []);
  return /*#__PURE__*/_jsx(Popover, {
    classes: {
      paper: styles.popover
    },
    open: isOpen,
    anchorEl: editorAnchor,
    onClose: onDismiss,
    testId: BundlePriceEditorTestIds.Popover(),
    children: /*#__PURE__*/_jsxs("form", {
      onSubmit: onSave,
      className: styles.popoverForm,
      "data-testid": BundlePriceEditorTestIds.PopoverForm(),
      children: [/*#__PURE__*/_jsx(CloseButton, {
        className: styles.closeBtn,
        testId: BundlePriceEditorTestIds.CloseButton(),
        onClick: onDismiss
      }), /*#__PURE__*/_jsx(BundlePriceEditorContent, {
        data: editorData,
        service: serviceWithChanges,
        onDataChange: setEditorData,
        onCancel: onDismiss,
        onInputFocus: onInputFocus,
        onInputBlur: onInputBlur
      })]
    })
  });
}